import React, { Component } from 'react';
import PubSub from 'pubsub-js'
import { meshLog } from "../../../utils/spUtils";
import {OUTPUT_PROFILE_DIALOG_HIDE} from "../../../const/infoConst"
import './outputFileDialog.less';
import close_btn from '../../../imgs/btn/close_btn.png';
import warning from "../../../imgs/item/warning.png";


//设备设置界面
export default class OutputFileDialog extends Component {
    constructor(a) {
        super(a);
        this.state = {
            control: 'Dim Level',
        }
    }



    closeBtnClick = async () => {
        meshLog("closeBtnClick");
        PubSub.publish(OUTPUT_PROFILE_DIALOG_HIDE,'')
    }

    openFileClick = async () => {
        meshLog("openFileClick");
        const inputElement = document.createElement('input');
        inputElement.type = 'file';
        inputElement.webkitdirectory = true; // 对于Chrome，允许选择文件夹
        inputElement.click();

        inputElement.onchange = (event) => {
            const files = event.target.files;
            console.log(files); // 处理选择的文件或文件夹
        };
    }


    render() {
        const { selectedValue } = this.state;
        return (
            <div className="output_container">
                <div className="ui_grey_bg" />
                <div className="output_dialog" style={{left:(document.body.clientWidth-600)/2}}>
                     {/* 关闭按钮 */}
                    <img className='closeBtn' src={close_btn} onClick={() => { this.closeBtnClick() }}/>
                    {/* 标题 */}
                    <div className="output_title">
                        <img className='icon' src={warning}/>
                        <span>Output the Report</span>
                    </div>
                    {/* 控制 */}
                    <div className='outputBg'>
                        <span>This report centers on the core status information of the current proiect is content not only covers the key details of areas and equipment* from the overall architectural perspective, but also simultaneously includes materials of regional floor plans and instructions related to equipment control.</span>
                    </div>
                    

                    {/* 底部按钮 */}
                    <div className="output-footer">
                        <button className='cancelBtn' onClick={() => { this.closeBtnClick() }}>Cancel</button>
                        <button className='okBtn' onClick={() => { this.openFileClick() }}>Confirm</button>
                    </div>
           
               
                </div>
            </div>
        );

    }
};